<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <ellipse cx="16" cy="14.5" rx="5" ry="5.5" stroke="var(--icon-color)" stroke-width="1.5" />
    <path d="M24 25.5C24 22.4704 22.0839 19.8603 19.3258 18.6768M8 25.5C8 22.4704 9.91614 19.8603 12.6742 18.6768"
        stroke="var(--icon-color)" stroke-width="1.5" />
    <circle cx="16" cy="16" r="13" stroke="var(--icon-color)" stroke-width="2" />
</svg>
